/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import Select, { components } from 'react-select';
import moment from 'moment';
import _ from "lodash";
import DatePicker from 'react-datepicker';

import './index.scss';
import closeIcon from '../../../../assets/images/close_icon_dark.svg'
import deleteIcon from '../../../../assets/images/delete-blue.svg'

const timeSelectDropdown = [
    {label:'Days of Week',value:'WEEKLY'},
    {label:'Specific Date',value:'SPECIFIC_DATE'}
];

const typeofRule = [
  {label:'All',value:'ALL'},
  {label:'Specific provider(s)',value:'SPECIFIC_PROVIDER'},
  {label:'Specific appointment type(s)',value:'SPECIFIC_SERVICE'},
  {label:'Specific operatory(s)',value:'SPECIFIC_RESOURCE'},
];

const daysOfWeek = [
  {label:'Sunday',value:'SUNDAY'},
  {label:'Monday',value:'MONDAY'},
  {label:'Tuesday',value:'TUESDAY'},
  {label:'Wednesday',value:'WEDNESDAY'},
  {label:'Thursday',value:'THURSDAY'},
  {label:'Friday',value:'FRIDAY'},
  {label:'Saturday',value:'SATURDAY'},
];

const frequencyUnitDropdown = [
  {label:'Day',value:'DAY'},
  {label:'Week',value:'WEEK'},
  {label:'Month',value:'MONTH'}
];

const prefrenceDropdown = [
  {label:'Every half an hour',value:'HALF_AN_HOUR'},
  {label:'Top of the hour',value:'TOP_OF_HOUR'},
  {label:'Every hour',value:'EVERY_HOUR'},
  {label:'Every fifteen minutes',value:'EVERY_FIFTEEN_MINUTES'},
  {label:'Every twenty minutes',value: 'EVERY_TWENTY_MINUTES'},
  {label:'Every ten minutes',value:'EVERY_TEN_MINUTES'},
  {label:'None',value:'NONE'},
]
const generateTimeRange =(from,to)=>{
    let range = [];
    for(let i=from;i<=to;i++){
        range.push({label:pad(i),value:i})
    }
    return range;
}
const pad =(d)=>{
  return (d < 10) ? '0' + d.toString() : d.toString();
}

const capitalize = s => s && s[0].toUpperCase() + s.slice(1)

const timeOfDay = generateTimeRange(1,12);
const fequencyRange = generateTimeRange(1,31);

const minutes = generateTimeRange(0,59);

const dropdownCustomStyle = {
    control: base => ({
      ...base,
      border: '1px solid #CFD0D1',
      // This line disable the blue border
      padding: '6px 12px',
      boxShadow: 'none',
      outLine:'none',
      '&:hover': {
        border: '1px solid #CFD0D1',
      }
    }),
    option: base => ({
      ...base,
      padding: '8px 15px',
    }),
    placeholder: base => ({
      ...base,
      color:'#4A4A4A'
    }),
    indicatorsContainer : base => ({
      ...base,
      color:'#4A4A4A'
    }),
    valueContainer: base => ({
      ...base,
      padding: '2px',
      color:'#4A4A4A'
    }),
  };
const timeCustomStyle ={
  control: base => ({
    ...base,
    border: '1px solid #CFD0D1',
    // This line disable the blue border
    padding: '6px 6px',
    boxShadow: 'none',
    outLine:'none',
    marginLeft: '5px',
    '&:hover': {
      border: '1px solid #CFD0D1',
    }
  }),
  valueContainer: base => ({
    ...base,
    padding: '0px',
    width:'29px'
  }),
  indicatorContainer : base => ({
    ...base,
  }),
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%"
}),
};

  const DropdownIndicator = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <i className="material-icons custom">arrow_drop_down</i>
        </components.DropdownIndicator>
      )
    );
  };

  const CustomOption = ({ innerProps, label, isSelected }) => {
    console.log('isSelected',isSelected);
    return <div {...innerProps} className="custom-input-option">
      <input className="custom-input-select" type="checkbox" checked={isSelected} readOnly />
      <span className="custom-input-option_lable">{label}</span>
    </div>
  };

  const isInArray =(obj, array) =>{
    return array.some(item => item.rule_id === obj.rule_id);
  }

  const mergeArrays = (arr1, arr2) =>{
    // Concatenate the two arrays
    const combinedArray = [...arr1, ...arr2];
    
    // Create a map to ensure uniqueness based on the 'id' property
    const uniqueMap = new Map();
    
    combinedArray.forEach(item => {
        if (uniqueMap.has(item.id)) {
            // Merge objects with the same id
            uniqueMap.set(item.id, { ...uniqueMap.get(item.id), ...item });
        } else {
            // Add new object
            uniqueMap.set(item.id, item);
        }
    });
    
    // Convert map values back to an array
    return Array.from(uniqueMap.values());
}

const filterService = (services) => {
  return filterServiceForAPI(services);
}

const filterServiceForAPI = (services) => {
  const filterdService = services? services.filter(service=>service.kind==='SESSION'):[];
  return filterdService;
}

Modal.setAppElement('#root');

class InstallLayover extends React.Component {
  constructor(props) {
    super(props);
    this.startRef = React.createRef();
    this.state = {
      timeType:'WEEKLY',
      selecedDayofWeek:[],
      selectedDate: new Date(),
      frequency:'WEEK',
      frequencyStartHour:9,
      frequencyStartMinute:0,
      frequencyStartDominion:'AM',
      frequencyEndDominion:'PM',
      frequencyEndHour:5,
      frequencyEndMinute:0,
      breakData:[],
      services:[],
      resource:[],
      preference: null,
      staffs:[],
      frequencyunit:'DAY',
      frequencyvalue:1,
      typeOfRuleSelected:'ALL'
    };
  }
  componentWillReceiveProps(nextProps) {
    const { editSchedule,  editScheduleData } = nextProps;
    if(editSchedule){
      console.log('editScheduleData',editScheduleData);
    }
  }

  componentDidMount(){
    const { editSchedule,  editScheduleData, business } = this.props;
    const { services, resources, staffs } = business.details;
    console.log('editSchedule',editSchedule, editScheduleData);
    if(editSchedule){
      console.log('editScheduleData',editScheduleData);

      const ifAllService = _.isEqual(_.sortBy(editScheduleData.service_ids), _.sortBy(filterServiceForAPI(services).map(service=>service.id)))
      const selectedService = ifAllService? [{name:'All Service',id:'ALL'}] : services.filter(service=> editScheduleData.service_ids.includes(service.id));
      let selectedResources = resources?.filter(resource=> editScheduleData.resource_ids.includes(resource.id)); 
      const allresource = _.isEqual(selectedResources.map(res=>res.id), resources.map(res=>res.id))
      const selectedStaffs =  staffs.filter(staff=> editScheduleData.staff_ids.includes(staff.id));
      console.log('allresource',allresource);
      let typeOfRuleSelected = 'ALL';
      if(selectedService.length<1 && selectedStaffs.length<1 && selectedResources.length>0){
        typeOfRuleSelected = 'SPECIFIC_RESOURCE';
      }else if((selectedResources.length<1 || allresource) && selectedStaffs.length<1 && selectedService.length>0){
        typeOfRuleSelected = 'SPECIFIC_SERVICE';
        selectedResources = [];
      }else if((selectedResources.length<1 || allresource) && selectedService.length<1  && selectedStaffs.length>0){
        typeOfRuleSelected = 'SPECIFIC_PROVIDER';
        selectedResources = [];
      }
      this.setState({
      timeType: editScheduleData?.day_of_week?.length>0?'WEEKLY':'SPECIFIC_DATE',
      selecedDayofWeek: editScheduleData.day_of_week.map(day=>({'label':capitalize(day.toLowerCase()) , 'value':day})),
      selectedDate: editScheduleData?.dates ? new Date(editScheduleData?.dates[0])  : new Date(),
      frequencyStartHour: eval(moment(editScheduleData.start_time,'HH:mm:ss').format('h')),
      frequencyStartMinute: eval(moment(editScheduleData.start_time,'HH:mm:ss').format('m')),
      frequencyStartDominion: moment(editScheduleData.start_time,'HH:mm:ss').format('A'),
      frequencyEndHour: eval(moment(editScheduleData.end_time,'HH:mm:ss').format('h')),
      frequencyEndMinute: eval(moment(editScheduleData.end_time,'HH:mm:ss').format('m')),
      frequencyEndDominion: moment(editScheduleData.end_time,'HH:mm:ss').format('A'),
      services: selectedService,
      resource: selectedResources,
      staffs: selectedStaffs,
      typeOfRuleSelected
      })
    }
  }
  
  onChange = (event) => {
    const { name, value: rawValue } = event.target;
    let value = rawValue;

    const newState = {};

    if (name === 'typeOfRuleSelected') {
      const { business } = this.props;
      const { resources: allresources } = business.details;
      value = rawValue.value;

      switch (value) {
        case 'SPECIFIC_RESOURCE':
          newState.services = [];
          newState.staffs = [];
          break;
        case 'SPECIFIC_PROVIDER':
          newState.services = [];
          newState.resource = allresources;
          break;
        case 'SPECIFIC_SERVICE':
          newState.staffs = [];
          newState.resource = allresources;
          break;
        default:
          break;
      }
    } else if (name === 'timeType') {
        value = rawValue.value;
        if (value === 'SPECIFIC_DATE') {
            newState.selecedDayofWeek = [];
            newState.selectedDate = new Date();
        }
    }

    const listofFields = ['timeType', 'frequencyunit', 'frequencyvalue', 'frequencyStartMinute', 'frequencyStartHour', 'frequencyEndHour', 'frequencyEndMinute', 'preference'];
    const arrayFields = ['services', 'staffs', 'resource', 'selecedDayofWeek'];

    if (arrayFields.includes(name)) {
      value = value || [];
    } else if (listofFields.includes(name) || (name === 'typeOfRuleSelected' && !('value' in event.target))) {
      value = value && typeof value === 'object' && 'value' in value ? value.value : value;
    }
    
    newState[name] = value;

    this.setState(newState, () => {
      console.log('STATE 123', this.state);
    });
  }

  onChangeBreak=(event)=>{
    let breakCopy = _.cloneDeep(this.state.breakData);
    breakCopy[event.target.index][event.target.name] =event.target.value.value
    this.setState({
      breakData: breakCopy
    })
  }
  handleChangeDate = (date, type) => {
    this.setState({
      [type]: date,
    });
  };

  datePickerVisible = (event, ref) => {
    const node = ref.current;
    node.setFocus();
  };
  deleteBreak=(removeIndex)=>{
    let breakCopy = _.cloneDeep(this.state.breakData);
    breakCopy.splice(removeIndex, 1);
    console.log('breakCopy1',breakCopy)
    this.setState({
      breakData: breakCopy
    })
    
  }
  // {label:'Specific provider(s)',value:'SPECIFIC_PROVIDER'},
  // {label:'Specific appointment type(s)',value:'SPECIFIC_SERVICE'},
  // {label:'Specific operatory(s)',value:'SPECIFIC_RESOURCE'},
  disabledAddButton=()=>{
    const { services, staffs, preference , resource, timeType, selecedDayofWeek, typeOfRuleSelected} = this.state;
    const { schedules } = this.props;
    const disabled = (schedules.addScheduleBlocks || (timeType === 'WEEKLY' && selecedDayofWeek.length<1) || (typeOfRuleSelected ==='SPECIFIC_SERVICE' && services.length<1 ) || (typeOfRuleSelected ==='SPECIFIC_PROVIDER' && staffs.length<1 ) || (typeOfRuleSelected ==='SPECIFIC_RESOURCE' && resource.length<1 ) || (typeOfRuleSelected ==='ALL' && (staffs.length<1 || resource.length<1  || services.length<1)) || this.isStartAndEndSame())
    return disabled;
  }


  getServiceIds = (services) => {
    if(services.length === 1 && services[0].id === 'ALL'){
      const { business } = this.props;
      const { services} = business.details;
      const servicesFiltered  = filterServiceForAPI(services);
      return servicesFiltered;
    }
    return services;

  }

  addTime=()=>{
    const { business, selectedData, editSchedule,  editScheduleData, auth } = this.props;
    const { timeType, resource, services ,selecedDayofWeek , selectedDate, preference,  
      frequencyStartHour, frequencyStartMinute,frequencyEndHour, frequencyEndMinute,breakData, frequencyvalue, frequencyunit, frequencyStartDominion, frequencyEndDominion, staffs} = this.state;
    const {  studio_id } = auth;
    const bzid = business.id || studio_id;  
    //const { services, resources, staffs} = business.details;
    const addOrUpdate = editSchedule? "UPDATE":"ADD";
   console.log('selectedData',selectedData , editScheduleData)

    const addData = {
      "business_id": bzid,
      "location_id": business?.details?.locations[0]?.id,
      "booking_type": "NEW_BOOKING", 
      "service_ids": this.getServiceIds(services).map(service=>service.id),
      "staff_ids": staffs.map(staff=>staff.id),
      "resource_ids": resource.length>0?resource.map(res=>res.id): business.details.resources.map(res=>res.id),
      "start_time": moment(frequencyStartHour+':'+frequencyStartMinute+' '+frequencyStartDominion,'h:m A').format('HH:mm:ss'),
      "end_time": moment(frequencyEndHour+':'+frequencyEndMinute+' '+frequencyEndDominion,'h:m A').format('HH:mm:ss'),
      ...(timeType==='WEEKLY' && {"day_of_week": selecedDayofWeek.map(day=>day.value)}),
      ...(timeType!=='WEEKLY' &&{ "dates": [moment(selectedDate).format('YYYY-MM-DD')]}),
      "slot_size": "PT0M",
      "is_booking_interval": false,
      "name": " ",
      "description": " "
  }
  if(editSchedule){
    const data = {"rule_id":editScheduleData.id, "rule_meta_data":addData };
    this.props.updateBlockRules(data);
  }else{
    this.props.addBlockRules(addData);
  }
  console.log('addData', addData);
  }

  isStartAndEndSame=()=>{
    const { frequencyStartHour, frequencyStartMinute , frequencyEndHour,frequencyEndMinute , frequencyStartDominion, frequencyEndDominion } = this.state;
    if(frequencyStartHour === frequencyEndHour && frequencyStartMinute === frequencyEndMinute && frequencyStartDominion === frequencyEndDominion ){
      return true;
    }
    return false;
  }

  render() {
    const { modelopen, closeServiceModal, schedules, business, selectedData, editSchedule,  editScheduleData  } = this.props;
    const{ timeType, selecedDayofWeek , selectedDate, frequencyvalue, frequencyunit , frequencyStartHour, frequencyStartMinute , frequencyEndHour,frequencyEndMinute,
       breakData, preference, resource , service , frequencyStartDominion, frequencyEndDominion, typeOfRuleSelected} = this.state;
       
    const { services, resources, staffs} = business.details;
    console.log('resources', resources);
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeServiceModal}
          className="Modal-block"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title"><div>Block time</div>
                  <div className="title_for">Define a time frame when TrueLark cannot book appointments</div>
              </div>
              <button className="modal-close" onClick={closeServiceModal}>
                <img src={closeIcon}></img>
              </button>
              <div className="modal-description">
                    <div className="frequency-type">
                        <div className="label">Apply to</div>
                        <div className="frequency-time_dropdwns">
                          <div className="frequency-time_dropdwns_select">
                              <Select
                                  components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                                  value={typeofRule.filter(c => c.value === typeOfRuleSelected)}
                                  getOptionLabel={(option) => option.label}
                                  getOptionValue={(option) => option.value}
                                  options={typeofRule}
                                  placeholder=''
                                  onChange={(event) => {
                                    this.onChange({target:{name:'typeOfRuleSelected', value:event}});
                                    }}
                                  styles={dropdownCustomStyle}
                              />
                          </div>
                        </div>
                        {(typeOfRuleSelected === 'SPECIFIC_SERVICE' || typeOfRuleSelected === 'ALL') && 
                        <div className="frequency-type">
                        <div className="label">Appointment type(s)</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={filterService(services).filter(item1 =>this.state?.services?.some(item2 => item2.id === item1.id))}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            options={_.sortBy(filterService(services),['name'])}
                            isMulti
                            noOptionsMessage={() => null}
                            onChange={(event) => {
                              this.onChange({target:{name:'services', value:event}});
                              }}
                            styles={dropdownCustomStyle}
                        />
                        </div>}
                        {(typeOfRuleSelected === 'SPECIFIC_RESOURCE'|| typeOfRuleSelected === 'ALL') && 
                    <div className="frequency-type">
                        <div className="label">Operatory</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={resources?.filter(item1 =>this.state?.resource.some(item2 => item2.id === item1.id))}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isMulti
                            noOptionsMessage={() => null}
                            options={_.sortBy(resources,['name'])}
                            onChange={(event) => {
                              this.onChange({target:{name:'resource', value:event}});
                              }}
                            styles={dropdownCustomStyle}
                        />
                    </div>}
                    {(typeOfRuleSelected === 'SPECIFIC_PROVIDER' || typeOfRuleSelected === 'ALL') && 
                    <div className="frequency-type">
                    <div className="label">Provider</div>
                    <Select
                        components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                        value={staffs?.filter(item1 =>this.state?.staffs.some(item2 => item2.id === item1.id))}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        options={_.sortBy(staffs,['name'])}
                        isMulti
                        noOptionsMessage={() => null}
                        onChange={(event) => {
                          this.onChange({target:{name:'staffs', value:event}});
                          }}
                        styles={dropdownCustomStyle}
                    />
                    </div>}
                    </div>


                    <div className="frequency-time">
                        <div className="label">Time</div>
                        <div className="frequency-time_dropdwns">
                        <div className="frequency-time_dropdwns_select">
                            <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={timeSelectDropdown.filter(c => c.value === timeType)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={timeSelectDropdown}
                            onChange={(event) => {
                              this.onChange({target:{name:'timeType', value:event}});
                              }}
                            styles={dropdownCustomStyle}
                            />
                        </div>
                       {timeType === 'WEEKLY' &&
                       <div className="frequency-time_dropdwns_dateselect">
                            <Select
                            components={{
                              Option: CustomOption, DropdownIndicator, IndicatorSeparator: () => null 
                            }}
                            value={daysOfWeek.filter(item1 =>selecedDayofWeek.some(item2 => item2.value === item1.value))}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={daysOfWeek}
                            isMulti
                            noOptionsMessage={() => null} 
                            closeMenuOnSelect={false}
                            onChange={(event) => {
                              this.onChange({target:{name:'selecedDayofWeek', value:event}});
                              }}
                            styles={dropdownCustomStyle}
                            />
                        </div>}
                         {timeType !== 'WEEKLY' &&<div className="frequency-time_dropdwns_dateselect">
                          <div onClick={(e) =>
                                  this.datePickerVisible(e, this.startRef)
                                }>
                                </div>
                          <DatePicker
                                  ref={this.startRef}
                                  selected={selectedDate}
                                  onChange={(date) =>
                                    this.handleChangeDate(date, 'selectedDate')
                                  }
                                  dateFormat="MMMM d, yyyy"
                                  placeholderText="Select Date"
                                  className="custom-datepicker" 
                                  minDate={new Date()}
                                  maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                                />
                        </div>
                        }

                        </div>
                    </div>
                    <div className="time-of-day">
                        <div className="time-of-day_label">From</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={timeOfDay.filter(c => c.value === frequencyStartHour)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={timeOfDay}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChange({target:{name:'frequencyStartHour', value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={minutes.filter(c => c.value === frequencyStartMinute)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={minutes}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChange({target:{name:'frequencyStartMinute', value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <div className="time-of-day_dominion" onClick={()=> this.onChange({target:{name:'frequencyStartDominion', value:frequencyStartDominion==='AM'?'PM':'AM'}})}>{frequencyStartDominion}</div>
                        <div className="time-of-day_divider">-</div>
                        <div className="time-of-day_label">To</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={timeOfDay.filter(c => c.value === frequencyEndHour)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={timeOfDay}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChange({target:{name:'frequencyEndHour', value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={minutes.filter(c => c.value === frequencyEndMinute)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={minutes}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChange({target:{name:'frequencyEndMinute', value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <div className="time-of-day_dominion" onClick={()=> this.onChange({target:{name:'frequencyEndDominion', value: frequencyEndDominion==='AM'?'PM':'AM'}})}>{frequencyEndDominion}</div>
                        
                    </div>
                    {this.isStartAndEndSame() && <div className='error-message'>From and to can't be same</div>}
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" disabled={this.disabledAddButton()} onClick={this.addTime}>{schedules?.addScheduleBlocks? (editSchedule?'UPDATING..':'SAVING..'):(editSchedule?'UPDATE':'SAVE')}</button>
                  <button className="btn btn--secondary btn--lg" onClick={closeServiceModal}>CANCEL</button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InstallLayover;
